<template>
  <div class="bg-image-full">
    <b-container>
      <div class="form-container">
        <form action @submit.prevent="login">
          <router-link to="/">
            <img :src="logo" class="mb-5 d-block mx-auto logo" alt />
          </router-link>
          <BaseSectionTitle :title="'Login'" :left="true" />
          <div class="contact-form">
            <BaseInput
              :label="'Email address'"
              v-model="username"
              v-validate="'required|email'"
              name="email"
            >
              <slot>
                <span class="error">{{errors.first('email')}}</span>
              </slot>
            </BaseInput>
            <BaseInput
              name="password"
              :label="'Password'"
              type="password"
              v-model="password"
              v-validate="'required'"
            >
              <slot>
                <span class="error">{{errors.first('password')}}</span>
              </slot>
            </BaseInput>
            <span class="error mb-5" v-if="loginFailed">These credentials do not match our records.</span>
            <BaseButton :label="'Sign In'" />
            <small class="text-center w-100 d-inline-block mt-2">
              <router-link to="/forget-password" class="medium opacity-5">Forgot password ?</router-link>
            </small>
            <small class="text-center w-100 d-inline-block mt-5">
              Don't have an account ?
              <router-link to="/register" class="link semibold">Register</router-link>
            </small>
          </div>
        </form>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from "@/api.js";
import BaseInput from "@/components/ui/Elements/BaseInput";
import BaseButton from "@/components/ui/Elements/BaseButton";
import { toast } from "@/mixins/mixins";
import auth from "@/auth.js";
export default {
  components: {
    BaseInput,
    BaseButton
  },
  mixins: [toast],
  data() {
    return {
      username: "",
      password: "",
      loginFailed: false
    };
  },
  computed: {
    logo() {
      return this.$store.state.logo;
    }
  },
  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.axios
            .post(`${api.url}/user-login`, {
              username: this.username,
              password: this.password
            })
            .then(response => {
              let res = response.data.userinfo;
              let token = res.api_token;
              let user_name = res.user_name;
              let user_id = res.user_id;
              let success = response.data.success;
              if (success === "1") {
                // Stores credentials in localstorage
                auth.login(user_name, token, user_id);
                // Tells vuex to update the data from localstorage
                let payload = {
                  token: token,
                  user_name: user_name,
                  user_id: user_id,
                  userLogged: true
                };
                this.$store.dispatch("login", payload);
                // Redirect to homepage
                this.$router.push("/");
              } else {
                this.loginFailed = true;
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
        }
      });
    }
  },
  mounted() {
    // If user completed registration then show the toast
    if (this.$route.params.success) {
      this.toast(
        "b-toaster-top-center",
        false,
        "success",
        "Registered successfully",
        "please log in to continue."
      );
      // If user tries to book cab without logged in
    } else if (this.$route.params.book) {
      this.toast(
        "b-toaster-top-center",
        false,
        "warning",
        "Please log in.",
        "login is required to book a cab."
      );
    } else if (this.$route.params.password_reset) {
      this.$bvToast.toast(`Please login with your new password.`, {
        toaster: "b-toaster-top-center",
        title: "Your Password has been reset.",
        autoHideDelay: 5000,
        appendToast: false,
        variant: "success"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 200px;
  max-height: 60px;
  object-fit: contain;
}

.container {
  @include for-size(mobile) {
    padding: 0px;
  }
}

.bg-image-full {
  @include flex-row-center;
  height: 100vh;
  width: 100vw;
  background: url("../../../assets/images/fleet-blur-hero.jpg");
}

.form-container {
  max-width: 500px;
  margin: 0 auto;
  background: rgba(249, 249, 251, 0.95);
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 25px;
  padding-bottom: 30px;
  width: 100%;
  border-radius: 4px;
  @include for-size(mobile) {
    border-radius: 0px;
    height: 100vh;
    background: white;
  }
}

.link {
  border-bottom: 1px solid #00cc37;
}

.semibold {
  font-weight: 600;
}
</style>
    